<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\courseConditionsManual-1.png" alt="" /></div>
                <div>
                    <p>①.メインツールバーの「学習状況」アイコンをクリックし、「受講状況」メニューを選択すると、「受講コース進捗状況」画面が表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\courseConditionsManual-2.png" alt="" /></div>
                <div>
                    <p>②.「受講コース進捗状況」画面では、コース名称、受講開始日、受講完了日、学習進捗率、アンケート・誓約書の提出状況などの情報が表示されています。</p>
                    <p>&nbsp;&nbsp;※ディフォルトで表示されているコースは、修了したコース（学習修了を申請したコース）は含まれていません。「修了コースを含む」はオフしている状態です。</p>
                </div>
                <div><img src="/static\images\ja\newManual\courseConditionsManual-3.png" alt="" /></div>
                <div>
                    <p>③.「修了コースを含む」をオンにすると、終了したコースを含めたコース一覧が表示されます。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>①.画面下部の「学習状況」アイコンをクリックすると、「受講状況」、「成績状況」メニューが表示されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\course_status_1.png" alt="" /></div>
                <div><p><b>「受講状況」メニューをクリックすると、「受講コース進捗状況」画面が表示されます。</b></p></div>
                <div><img src="/static\images\ja\newManual\mobile\course_status_course_status_1.png" alt="" /></div>
                <div><p>②.コースを検索したい場合に検索ボックスにコース名称を入力し、「検索」ボタンを押下してください。</p></div>
                <div><p>③.「修了したコースを含める」をオンにすると、修了したコース（学習修了を申請したコース）も一覧に表示されます。</p></div>
                <div><p>④.受講しているコースの一覧は表示されています。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\course_status_course_status_2.png" alt="" /></div>
                <div><p>⑤.コースを選択すると、コースの「受講開始日」、「受講完了日」、「チャプター数」、「学習進捗率」、「証明書」などを表示する「学習状況詳細」画面に遷移します。コースに参加したい場合は、画面下部にある「参加」ボタンを押下することで「コース受講」画面に遷移できます。</p></div>
                <div><p>● 受講開始日: コースに参加した日</p></div>
                <div><p>● 受講修了日: コースを修了した日</p></div>
                <div><p>● チャプター数: コースのチャプターの総数</p></div>
                <div><p>● 学習進捗率: 学習したチャプターの数はチャプター総数の割合</p></div>
                <div><p>● 証明書: コースの修了証明書</p></div>
                <div><img src="/static\images\ja\newManual\mobile\course_status_course_status_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/studySituationList_manual.vue